import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-slate-900 text-slate-400 py-12 px-6 text-center text-sm" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <p className="mb-4" data-id="element-60">
          © 2026 Clave de Paz. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-6 mb-8" data-id="element-61">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-slate-200 underline transition-colors" data-id="element-62">
            Políticas de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-slate-200 underline transition-colors" data-id="element-63">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-xs text-slate-500 max-w-xl mx-auto" data-id="element-64">
          Descargo de responsabilidad: Este material tiene fines educativos e
          informativos. No reemplaza el asesoramiento legal ni la terapia
          psicológica profesional. Si te encontrás en una situación de violencia
          o peligro físico, por favor contactá a las autoridades locales
          inmediatamente.
        </p>
      </div>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm" data-id="element-65">
          <div className="bg-white text-slate-900 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative text-left shadow-2xl" data-id="element-66">
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-900 bg-slate-100 rounded-full p-2 transition-colors" data-id="element-67">
              <X size={20} data-id="element-68" />
            </button>

            {activeModal === 'privacy' ? <div data-id="element-69">
                <h2 className="text-2xl font-bold mb-6 font-playfair text-slate-900" data-id="element-70">
                  Políticas de Privacidad
                </h2>
                <div className="space-y-4 text-slate-600 leading-relaxed" data-id="element-71">
                  <p data-id="element-72">
                    Tu privacidad es importante para nosotros. Es política de
                    Clave de Paz respetar tu privacidad con respecto a cualquier
                    información que podamos recopilar a través de nuestro sitio
                    web.
                  </p>
                  <p data-id="element-73">
                    Solo solicitamos información personal cuando realmente la
                    necesitamos para brindarte un servicio. La recopilamos por
                    medios justos y legales, con tu conocimiento y
                    consentimiento.
                  </p>
                  <p data-id="element-74">
                    No compartimos ninguna información de identificación
                    personal públicamente ni con terceros, excepto cuando lo
                    exija la ley.
                  </p>
                  <p data-id="element-75">
                    Nuestro sitio web puede tener enlaces a sitios externos que
                    no son operados por nosotros. Ten en cuenta que no tenemos
                    control sobre el contenido y las prácticas de estos sitios,
                    y no podemos aceptar responsabilidad u obligación por sus
                    respectivas políticas de privacidad.
                  </p>
                </div>
              </div> : <div data-id="element-76">
                <h2 className="text-2xl font-bold mb-6 font-playfair text-slate-900" data-id="element-77">
                  Términos y Condiciones
                </h2>
                <div className="space-y-4 text-slate-600 leading-relaxed" data-id="element-78">
                  <p data-id="element-79">
                    Al acceder al sitio web de Clave de Paz, aceptas estar
                    sujeto a estos términos de servicio, a todas las leyes y
                    regulaciones aplicables, y aceptas que eres responsable del
                    cumplimiento de las leyes locales aplicables.
                  </p>
                  <p data-id="element-80">
                    Los materiales contenidos en este sitio web están protegidos
                    por las leyes de derechos de autor y marcas comerciales
                    aplicables.
                  </p>
                  <p data-id="element-81">
                    Se concede permiso para descargar temporalmente una copia de
                    los materiales (información o software) en el sitio web de
                    Clave de Paz solo para visualización transitoria personal y
                    no comercial.
                  </p>
                  <p data-id="element-82">
                    Este material tiene fines educativos e informativos. No
                    reemplaza el asesoramiento legal ni la terapia psicológica
                    profesional.
                  </p>
                </div>
              </div>}
          </div>
        </div>}
    </footer>;
}